module.exports = __webpack_public_path__ + "static/chris-s-aabba134face95fd4fbf75fdffc74d16.png";